<template>
    <div>
        <e-dialog
                 dialogTitle="产品质量评价申请须知"
                checkTip=""
                :centerDialogVisible="applicationGuidVisible"
                 :showCloseBtn="falseFlag"
                :showBtn="falseFlag"
                @resetPopupData="resetPopupData"
                :popupWidth="'800px'">
            <div class="application-guide-wrapper">
                <div> 1.总则</div>
                <div class="margin-b10">本须知明确了易派客产品质量评价（EPEC Quality Evaluation，以下简称为“EQE”）的流程、质量分级标准、费用说明等方面的管理要求。</div>

                <div>2.产品质量评价流程</div>
                <div class="margin-b10">产品质量评价流程分为注册、申请、支付评价费用、审核与受理、质量评价、评价报告反馈等步骤。</div>

                <div>2.1.注册</div>
                <div class="margin-b10">申请产品质量评价的供应商（以下简称“申请人”），需在易派客平台完成注册、身份认证，填报企业基本信息。</div>

                <div>2.2.申请</div>
                <div class="margin-b10">申请人根据EQE公告自愿提出申请。</div>

                <div>2.2.1申请条件</div>
                <div class="margin-b10">--申请人需为具备独立的民事行为能力、能够独立承担民事责任的独立法人，可以是生产制造企业，也可以是非生产制造企业（包括但不限于经销商、流通商、代理商），
                    但必须能够提供技术支持、现场服务、库存储备、物流运输、仓储配送等集成供应服务。同时，需具备评价质量评价办法中所列举的必须满足的基本条件。</div>

                <div class="margin-b10">--申请人如需使用产品质量评价结果，须至少提前3个月提出申请。</div>

                <div >（1）生产制造企业所提供检测的样品为本企业生产，需在提交申请且资料初审通过后具备评价条件，供评价机构按相应的产品质量评价办法抽样进行检测。</div>

                <div class="margin-b10">（2）非生产制造企业提供或具有生产企业出具的经销商授权书、代理书、原产地证明等材料。</div>

                <div>2.2.2申请与支付</div>
                <div>--申请人在申请界面根据EQE评价办法，选择拟申请评价的物资品种。</div>
                <div>--上传资质信息、供应服务能力信息，填写发票及邮寄信息、联系人信息。</div>
                <div>--上传签章版《易派客产品质量评价委托协议》的扫描件后，提交申请。</div>
                <div class="margin-b10">--开通在线支付功能，在线支付产品质量评价费用。</div>

                <div>2.3审核与受理</div>
                <div>申请提交后，相关部门在3个工作日内，按照申请的产品质量评价办法对申请人的基本资质进行初步审查。</div>
                <div class="margin-b10">对于符合评价条件的，予以审核通过，产品质量评价申请正式受理；不符合评价条件的，予以审核不通过，同时明确拒绝的理由。申请人可按照拒绝理由修改后，再次提交申请（无需再支付评价费用）。</div>

                <div>2.4质量评价</div>
                <div>易派客平台自动出具委托单，委托具有专业资质的权威评价机构开展产品质量评价，同时发出通知单提醒申请人做好相关准备工作。</div>
                <div>（1）生产制造企业的产品质量评价，分为现场审查和样品检测两个环节。</div>
                <div class="margin-b10">（2）非生产制造企业的产品质量评价，仅有现场审查环节。</div>

                <div>2.4.1现场审查</div>
                <div>评价机构依据产品质量评价标准，对申请人的相关资质、质保体系、人员构成、检验检测能力、销售业绩等考察内容，到申请人的现场进行考察。</div>
                <div>生产制造企业还将考察生产装备、研发能力、原材料控制、生产过程控制、国际竞争力等。</div>
                <div>现场审查基本流程为：</div>
                <div>---首次会：评价机构说明现场审查内容和相关要求。</div>
                <div>---现场审查：评价机构开展现场审查核实工作，申请人予以配合。</div>
                <div class="margin-b10">---末次会：评价机构通报审查情况，申请人签字认可。</div>

                <div>2.4.2样品检测（仅对生产制造企业适用）</div>
                <div class="margin-b10">检测样品由评价机构到申请人的现场抽样，并按照评价标准所设定的检测内容和指标进行检测。</div>

                <div>2.5评价报告</div>
                <div class="margin-b10">评价机构按照产品质量评价标准对所申请产品进行专业的检测和评审，出具评价报告并上传至易派客平台。评价报告中对所申请产品的质量分级，给出最终评定。申请人可在易派客平台上查看评价报告。</div>

                <div>3.产品质量分级方法</div>
                <div>产品质量分级采用计分分级法。各项评价指标全部量化(各项分值视物资品种具体确定)，以最终得分评判产品等级。</div>
                <div>（1）工厂基本资质为否决项，如有不符合项，不进行后续评价；</div>
                <div>（2）生产检验能力评价；</div>
                <div>（3）工厂研发能力评价；</div>
                <div>（4）质量保证体系运行评价；</div>
                <div>（5）国际竞争能力评价；</div>
                <div>（6）产品性能评价。</div>
                <div class="margin-b10">非生产制造企业进行第（1）、（4）项产品性能评价。</div>

                <div>4.监督和管理</div>
                <div class="margin-b10" >对在产品质量评价报告有效期内的申请人，采用定期复查和不定期抽查的方式进行监督管理，重点考查其产品质量和质量保证体系运行状况。</div>
                <div>4.1评价</div>
                <div>产品质量评价报告有效期为三年。</div>
                <div>（1）评价包括工厂基本资质、质量保障能力评价，生产制造企业还包括工厂研发能力评价、产品质量检测结果评判。</div>
                <div>（2）产品质量评价报告有效期内，在中国石化以及易派客平台运营方组织的质量抽检中被查出有质量问题的，必须进行重新评价。</div>
                <div>（3）在产品质量评价报告有效期内，如出现以下重大事项，则质量评价结果予以作废，并在二年内不可提交质量评价申请：</div>
                <div>（1）产品在使用过程中出现质量问题，造成直接损失50万元以上的；</div>
                <div>（2）因质量问题被用户诉讼法律并败诉的；</div>
                <div class="margin-b10">（3）在国家有关部门质量抽检中被查出不合格的。</div>

                <div>4.2不定期抽查</div>
                <div class="margin-b10">根据整个行业产品质量状况、用户反馈意见和投诉情况等，中国石化以及易派客平台运营方有权对在产品质量评价报告有效期内的申请人随时进行抽查。</div>

                <div class="margin-b10">5.评价费用</div>
                <div>5.1生产制造企业</div>
                <div>产品质量评价费，由现场审查费和产品检测费（初评检测费和复评检测费）两部分组成 ，申请评价时需一并支付。</div>
                <div>对于首次申请的申请人，需交纳现场审查费27000元，现场审查费针对同一家评价机构3年内只支付一次（申请人生产条件发生重大变化情况或甲方自愿再次申请的除外）。</div>
                <div class="margin-b10">产品检测费按照不同产品类别以及测试项目等工作量的不同产生相应的费用，具体金额以易派客平台公布为准。</div>

                <div>5.2非生产制造企业</div>
                <div>按照石化物料分类代码，每申请一个大类物资品种的产品质量评价费为27000元。</div>

                <div class="margin-b10">如申请多个不同大类物资品种，则需交纳相应类别个数的产品质量评价费。</div>

                <div class="margin-b10">5.3如有特殊业务发生涉及费用问题，以委托协议为准进行处理。</div>

                <div>6.额外差旅费用</div>
                <div>出现下列情况之一，由甲方参照国家强制产品认证收费标准自行承担评价机构的差旅费：</div>
                <div>（1）由于甲方多次申请或准备不充分，导致评价机构赴现场超过一次的（评价办法发布滞后导致评价机构多次赴现场的情况除外）；</div>
                <div class="margin-b10">（2）按照地市级区划计算，甲方产品生产地超过两地的。</div>

                <div>7.异议和申诉</div>
                <div class="margin-b10">申请人对评价结果有异议时，可向易派客电子商务平台提出申诉。</div>

                <div>联系电话：95388-5。</div>

            </div>
          <template  #checkTipFlag >
              <div  style="margin-bottom: -20px;margin-top: 16px">
                  <el-checkbox v-model="checkedValue"> 我已阅读并知晓产品质量评价申请须知的全部内容</el-checkbox>
                  <eui-btn type="primary"  @click="submitPopupData" style="margin-left: 12px"
                           :disabled="!checkedValue">下一步</eui-btn>
              </div>
          </template>
        </e-dialog>
    </div>
</template>

<script>
    import eDialog from "@/modules/projectA/components/common/e-dialog.vue";
    export default {
        name: "applicationGuideDialog",
        components:{eDialog},
        props:{
            applicationGuidVisible:Boolean,
        },
        data(){
            return{
                falseFlag:false,
                checkedValue:false,
            }
        },
        methods:{
            resetPopupData(){
                this.$emit('closeDialog');
            },
            submitPopupData(){
                this.$emit('checkEvaluationApplyConditionAfter');
            },
        }
    }
</script>

<style scoped lang="scss">
@import '../../../../../assets/css/scrollbar.scss';
.application-guide-wrapper{
    height: 380px;
    overflow-y: auto;
    div{
        color: #666;
        font-size: 14px;
        line-height: 22px;
        font-weight: 350;
    }
}
</style>